(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ladd-quiz"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   MOTEUR DU QUIZ (données + logique). Aucune dépendance au DOM.
   Pour ajouter un produit : copier une ligne du CATALOGUE avec
   le handle Shopify exact, puis ajuster les critères.
   ============================================================ */
class LaddQuizEngine {
  constructor(products) {
    /* products : { handle: { price (centimes), url, variants: [{id, t, a}] } } */
    this.products = products || {};

    this.FINISHES = [
      { id: 'noir', label: 'Noir mat', re: /noir/i, bg: '#1f1f1f' },
      { id: 'chrome', label: 'Chrome', re: /chrom/i, bg: 'linear-gradient(135deg,#fbfbfb 0%,#b7babe 45%,#eef0f1 62%,#9da1a5 100%)' },
      { id: 'or', label: 'Or brossé', re: /(^|[^a-zà-ÿ])or(?![a-zà-ÿ])(?!\s*rose)/i, bg: 'linear-gradient(135deg,#e6cb91 0%,#b8914a 55%,#dcbd7e 100%)' },
      { id: 'orrose', label: 'Or rose', re: /or rose|bronze/i, bg: 'linear-gradient(135deg,#ecc6b8 0%,#b98472 55%,#dfb1a1 100%)' },
      { id: 'gris', label: 'Gris brossé', re: /gris|nickel/i, bg: 'linear-gradient(135deg,#a9a9a7 0%,#6f6f6d 55%,#9c9c9a 100%)' },
      { id: 'blanc', label: 'Blanc', re: /blanc/i, bg: '#ffffff' },
    ];

    /* t : parcours. pose : app (apparente), enc (encastrée), sm (sans mitigeur).
       exp : ce que le modèle apporte (pluie, cascade, massage, led, temp).
       big : grande tête de pluie. secu : sécurité anti-brûlure renforcée.
       why : 2 atouts affichés sous la carte (70 caractères maximum). */
    this.CATALOGUE = {
      /* ---------- COLONNES APPARENTES ---------- */
      'colonne-douche-mitigeur-3-voies': { t: 'colonne', pose: 'app', bain: true, exp: ['pluie'],
        why: ['Pluie, douchette et bec baignoire sur un seul bloc', 'Corps en laiton, 5 finitions'] },
      'colonne-de-douche-premium-pluie-douchette-bec-baignoire-6-finitions': { t: 'colonne', pose: 'app', bain: true, big: true, exp: ['pluie'],
        why: ['Bec baignoire intégré et tablette de 38,5 cm', 'Tête de pluie de 28 cm, 6 finitions'] },
      'colonne-douche-thermostatique-digital-noir': { t: 'colonne', pose: 'app', thermo: true, big: true, exp: ['pluie', 'temp'],
        why: ['La température s\'affiche avant d\'entrer, sans pile', 'Pluie large de 31 × 20 cm'] },
      'colonne-douche-thermostatique-carre-inox': { t: 'colonne', pose: 'app', thermo: true, secu: true, exp: ['pluie'],
        why: ['Bouton de sécurité anti-brûlure', 'S\'adapte aux plafonds bas (96 à 128 cm)'] },
      'colonne-douche-thermostatique-laiton': { t: 'colonne', pose: 'app', thermo: true, big: true, exp: ['pluie'],
        why: ['Tête de pluie de 20, 25 ou 30 cm au choix', 'Laiton et cartouche céramique'] },
      'colonne-douche-thermostatique-acier-inox': { t: 'colonne', pose: 'app', thermo: true, exp: ['pluie'],
        why: ['Une poignée par réglage : prise en main immédiate', 'Corps en inox 304, cartouche céramique'] },
      'colonne-douche-thermostatique-digital': { t: 'colonne', pose: 'app', thermo: true, big: true, exp: ['pluie', 'temp'],
        why: ['4 sorties, dont un spray pour rincer la cabine', 'Température affichée, sans pile'] },
      'colonne-de-douche-thermostatique-avec-affichage-digital-douche-pluie-noir-chrome': { t: 'colonne', pose: 'app', thermo: true, big: true, exp: ['pluie', 'temp'],
        why: ['Température affichée au degré près, sans pile', 'Tablette intégrée pour vos flacons'] },
      'colonne-de-douche-thermostatique-luxe-brossee-4-voies-pluie-cascade': { t: 'colonne', pose: 'app', thermo: true, big: true, exp: ['pluie', 'cascade'],
        why: ['Une cascade tonique à hauteur de nuque', 'Tablette-mitigeur de 37 cm'] },
      'colonne-de-douche-thermostatique-en-laiton-confort-securite': { t: 'colonne', pose: 'app', thermo: true, secu: true, exp: ['pluie'],
        why: ['Coupe l\'eau si l\'eau froide s\'arrête', 'Laiton massif, 2 designs de mitigeur'] },
      'colonne-de-douche-thermostatique-noir-chrome-design': { t: 'colonne', pose: 'app', big: true, exp: ['pluie'],
        why: ['Un seul geste pour le débit et la température', 'Entraxe réglable de 13,5 à 16,5 cm'] },
      'colonne-de-douche-3-voies-hauteur-reglable-gris-brosse': { t: 'colonne', pose: 'app', big: true, exp: ['pluie'],
        why: ['Commande mécanique, rien à programmer', 'Gris brossé : les traces d\'eau se voient moins'] },
      'colonne-de-douche-4-voies-a-affichage-digital-gris-brosse': { t: 'colonne', pose: 'app', exp: ['pluie', 'temp'],
        why: ['Température affichée, sans pile', '4 sorties, dont un spray de rinçage'] },
      'colonne-de-douche-moderne-affichage-digital-mitigeur-mecanique': { t: 'colonne', pose: 'app', big: true, exp: ['pluie', 'temp'], preferTemp: /avec/i,
        why: ['Écran de température en option', 'Commande façon piano, sélection par boutons'] },
      /* ---------- HYDROMASSANTES APPARENTES ---------- */
      'colonne-de-douche-hydromassante-jets-de-massage-rangement-integre': { t: 'colonne', pose: 'app', exp: ['pluie', 'massage'],
        why: ['Des jets qui massent le dos et les lombaires', 'Niche de rangement intégrée'] },
      'colonne-de-douche-hydromassante-a-affichage-digital-led-massage-detente': { t: 'colonne', pose: 'app', big: true, exp: ['pluie', 'cascade', 'massage', 'temp'],
        why: ['6 fonctions, dont jets de massage et cascade', 'Température affichée, sans pile'] },
      'colonne-de-douche-hydromassante-a-affichage-digital-led-cascade-massage': { t: 'colonne', pose: 'app', big: true, exp: ['pluie', 'cascade', 'massage', 'led', 'temp'],
        why: ['LED alimentées par l\'eau, sans pile ni câble', 'Jets de massage, cascade et température affichée'] },
      'colonne-de-douche-hydromassante-pluie-cascade-jets-led': { t: 'colonne', pose: 'app', big: true, exp: ['pluie', 'cascade', 'massage', 'led'],
        why: ['LED alimentées par l\'eau, sans pile ni câble', 'Jets massants, cascade et bec inférieur'] },
      /* ---------- SANS MITIGEUR ---------- */
      'colonne-de-douche-pluie-noir-mat-chrome-ensemble-douche-avec-douchette': { t: 'colonne', pose: 'sm', exp: ['pluie'],
        why: ['Se branche sur votre mitigeur actuel', 'Pluie de 29 × 19 cm et douchette de 24 cm'] },
      /* ---------- ENCASTRABLES ---------- */
      'colonne-de-douche-encastrable-luxe-led-pluie-cascade-douchette': { t: 'colonne', pose: 'enc', thermo: true, secu: true, big: true, exp: ['pluie', 'cascade', 'led'], avoid: /seulement/i,
        why: ['Éclairage LED couleurs, télécommande incluse', 'Butée de sécurité à 38 °C'] },
      'colonne-de-douche-encastrable-thermostatique-pluie-cascade': { t: 'colonne', pose: 'enc', thermo: true, secu: true, big: true, exp: ['pluie', 'cascade'],
        why: ['Pluie de 30 cm, cascade et douchette', 'Bouton anti-brûlure'] },
      'colonne-de-douche-encastrable-thermostatique-ciel-carre': { t: 'colonne', pose: 'enc', thermo: true, big: true, exp: ['pluie'],
        why: ['Ciel carré aligné sur votre carrelage', '20, 25 ou 30 cm au choix'] },
      'colonne-de-douche-encastrable-luxe-hydromassante-4-fonctions': { t: 'colonne', pose: 'enc', thermo: true, big: true, exp: ['pluie', 'cascade', 'massage', 'temp'],
        why: ['Pluie XXL de 63 cm et 4 jets orientables', 'Température verrouillée et affichée'] },
      'colonne-de-douche-encastrable-or-brosse-luxe-confort': { t: 'colonne', pose: 'enc', big: true, exp: ['pluie'],
        why: ['Tête ultrafine de 30 ou 40 cm, orientable', 'Seules la tête et la commande restent visibles'] },
      'colonne-de-douche-encastrable-ronde-pluie-douchette-noir-inox-brosse-rose-gold-or-brosse': { t: 'colonne', pose: 'enc', big: true, exp: ['pluie'],
        why: ['Pomme ronde de 20, 25 ou 30 cm au choix', 'Corps en laiton massif'] },
      'colonne-de-douche-encastrable-elegance-confort': { t: 'colonne', pose: 'enc', big: true, exp: ['pluie', 'cascade'],
        why: ['Tête panoramique de 55 cm : pluie ou cascade', 'Une commande par sortie d\'eau'] },
      'colonne-de-douche-encastrable-ciel-de-pluie-6-finitions': { t: 'colonne', pose: 'enc', big: true, exp: ['pluie'],
        why: ['Pluie et douchette en même temps', 'Ciel de 20, 25 ou 30 cm, 6 finitions'] },
      'colonne-de-douche-encastrable-noire-carree-2-ou-3-voies': { t: 'colonne', pose: 'enc', bain: true, big: true, exp: ['pluie', 'cascade'],
        why: ['Version 3 voies : cascade ou sortie baignoire', 'Pommeau de 30 ou 40 cm'] },
      'colonne-de-douche-encastrable-or-rose-brosse-bain-et-douche': { t: 'colonne', pose: 'enc', bain: true, big: true, exp: ['pluie'],
        why: ['Ciel de pluie, bec baignoire et douchette', 'Finition PVD qui ne jaunit pas'] },

      /* ---------- ROBINETS ---------- */
      'mitigeur-lavabo-bec-haut-vasque-a-poser': { t: 'robinet', vasque: ['basse'], rank: 1,
        why: ['210 mm sous le bec, pour une vasque posée', 'Flexibles fournis, perçage standard'] },
      'mitigeur-lavabo-bec-bas': { t: 'robinet', vasque: ['encastre'], rank: 2,
        why: ['175 mm de haut, pour un lavabo encastré', 'Kit de pose complet fourni'] },
      'mitigeur-lavabo-poignee-moletee': { t: 'robinet', vasque: ['encastre', 'basse'], rank: 3,
        why: ['Poignée moletée qui ne glisse pas', 'Hauteur intermédiaire de 160 mm'] },
      'robinet-lavabo-design-courbe': { t: 'robinet', vasque: ['basse'], rank: 4,
        why: ['185 mm sous le bec, une courbe en arc', 'Laiton, cartouche céramique anti-fuite'] },
      'mitigeur-lavabo-bec-haut-xl': { t: 'robinet', vasque: ['haute'], rank: 5,
        why: ['290 mm sous le bec, pour une vasque bol', 'Corps en acier inoxydable'] },
      'mitigeur-lavabo-encastre-mural': { t: 'robinet', vasque: ['mur'], rank: 6,
        why: ['Plan de vasque entièrement dégagé', 'Bec de 15, 21 ou 26 cm, pivotant'] },

      /* ---------- DOUCHETTES WC ---------- */
      'douchette-wc-eau-froide-kit-mural': { t: 'wc', eau: 'froide', rank: 1,
        why: ['Se branche sur l\'arrivée de la chasse d\'eau', 'Kit complet, sans percer le mur'] },
      'douchette-wc-mitigeur-eau-chaude-carre': { t: 'wc', eau: 'chaude', forme: 'carre', rank: 2,
        why: ['L\'eau à la température que vous réglez', 'Laiton massif, finition PVD'] },
      'douchette-wc-mitigeur-eau-chaude-rond': { t: 'wc', eau: 'chaude', forme: 'rond', rank: 3,
        why: ['Deux rosaces rondes, pose discrète', 'Gâchette en laiton, flexible inox ou PVC'] },
    };

    this.QUESTIONS = {
      colonne: [
        { id: 'usage', title: 'Votre colonne va équiper…', options: [
          { v: 'douche', l: 'Une douche' },
          { v: 'bain', l: 'Une baignoire', h: 'Avec un bec pour remplir le bain' } ] },
        { id: 'travaux', title: 'Vous refaites votre salle de bain ?', options: [
          { v: 'non', l: 'Non, je remplace ma colonne actuelle', h: 'Pose sur vos arrivées d\'eau, sans toucher au mur' },
          { v: 'oui', l: 'Oui, je rénove murs et carrelage', h: 'Les modèles encastrés deviennent possibles' },
          { v: 'garde', l: 'Je garde mon mitigeur', h: 'Je change seulement la pluie et la douchette' } ] },
        { id: 'qui', title: 'Qui va utiliser la douche ?', options: [
          { v: 'adultes', l: 'Des adultes' },
          { v: 'enfants', l: 'Toute la famille, avec des enfants' },
          { v: 'seniors', l: 'Des personnes âgées aussi' } ] },
        { id: 'envie', title: 'Qu\'aimeriez-vous retrouver chaque matin ?', options: [
          { v: 'pluie', l: 'Une grande pluie, tout simplement' },
          { v: 'cascade', l: 'Une cascade sur la nuque et les épaules' },
          { v: 'massage', l: 'Des jets qui massent le dos' },
          { v: 'led', l: 'Une lumière LED, ambiance spa' },
          { v: 'temp', l: 'La température affichée avant d\'entrer' } ] },
        { id: 'finition', type: 'finish', title: 'Quelle finition pour votre salle de bain ?' },
      ],
      robinet: [
        { id: 'vasque', title: 'Où va se poser votre robinet ?', help: 'Repère : mesurez la hauteur du bord de la vasque depuis le plan.', options: [
          { v: 'haute', l: 'Sur une vasque posée haute', h: 'Bord à plus de 12 cm du plan, type bol' },
          { v: 'basse', l: 'Sur une vasque posée basse', h: 'Bord à moins de 12 cm du plan' },
          { v: 'encastre', l: 'Sur un lavabo encastré ou un plan vasque' },
          { v: 'mur', l: 'Directement au mur', h: 'Pose encastrée, à prévoir en rénovation' },
          { v: 'nsp', l: 'Je ne sais pas encore' } ] },
        { id: 'finition', type: 'finish', title: 'Quelle finition pour votre robinet ?' },
      ],
      wc: [
        { id: 'eau', title: 'Avez-vous l\'eau chaude à côté de vos WC ?', help: 'Dans la plupart des toilettes, seule l\'arrivée de la chasse d\'eau sort du mur : c\'est de l\'eau froide.', options: [
          { v: 'froide', l: 'Non, seulement l\'eau froide de la chasse' },
          { v: 'chaude', l: 'Oui, l\'eau chaude et l\'eau froide' },
          { v: 'nsp', l: 'Je ne sais pas' } ] },
        { id: 'forme', title: 'Quel style vous plaît ?', options: [
          { v: 'rond', l: 'Rond', h: 'Deux rosaces rondes au mur' },
          { v: 'carre', l: 'Carré', h: 'Un bloc mural aux lignes droites' },
          { v: 'any', l: 'Peu importe' } ] },
        { id: 'finition', type: 'finish', title: 'Quelle finition pour votre douchette ?' },
      ],
    };

    this.ENVIE_MISS = {
      cascade: 'Sans cascade', massage: 'Sans jets de massage',
      led: 'Sans éclairage LED', temp: 'Sans affichage de la température',
    };
  }

  /* ---------- Outils ---------- */
  handles(path) {
    return Object.keys(this.CATALOGUE).filter((h) => this.CATALOGUE[h].t === path && this.products[h]);
  }
  finish(id) { return this.FINISHES.find((f) => f.id === id); }
  finishesOf(handle) {
    const p = this.products[handle]; const c = this.CATALOGUE[handle];
    if (!p) return [];
    if (c && c.fins) return c.fins.slice();
    const out = [];
    p.variants.forEach((v) => {
      if (c && c.avoid && c.avoid.test(v.t)) return;
      const f = this.FINISHES.find((x) => x.re.test(v.t));
      if (f && !out.includes(f.id)) out.push(f.id);
    });
    return out;
  }
  variantFor(handle, answers) {
    const p = this.products[handle]; const c = this.CATALOGUE[handle] || {};
    if (!p || !p.variants.length) return null;
    let list = p.variants.filter((v) => !(c.avoid && c.avoid.test(v.t)));
    if (!list.length) list = p.variants;
    const fin = answers && this.finish(answers.finition);
    if (fin) { const m = list.filter((v) => fin.re.test(v.t)); if (m.length) list = m; }
    if (answers && answers.envie === 'temp' && c.preferTemp) { const m = list.filter((v) => c.preferTemp.test(v.t)); if (m.length) list = m; }
    const avail = list.filter((v) => v.a);
    return (avail[0] || list[0]).id;
  }
  price(h) { return (this.products[h] && this.products[h].price) || 0; }

  /* ---------- Enchaînement des questions ---------- */
  question(path, id) { return this.QUESTIONS[path].find((q) => q.id === id); }
  next(path, a) {
    if (path === 'colonne') {
      if (!a.usage) return 'usage';
      if (a.usage === 'bain') return 'results';
      if (!a.travaux) return 'travaux';
      if (a.travaux === 'garde') return 'results';
      if (!a.qui) return 'qui';
      if (!a.envie) return 'envie';
      if (!a.finition) return this.finishOptions(path, a).length > 1 ? 'finition' : 'results';
      return 'results';
    }
    if (path === 'robinet') {
      if (!a.vasque) return 'vasque';
      if (!a.finition) return this.finishOptions(path, a).length > 1 ? 'finition' : 'results';
      return 'results';
    }
    if (path === 'wc') {
      if (!a.eau) return 'eau';
      if (a.eau !== 'chaude') return 'results'; /* eau froide : aucune question de finition */
      if (!a.forme) return 'forme';
      if (!a.finition) return this.finishOptions(path, a).length > 1 ? 'finition' : 'results';
      return 'results';
    }
    return 'results';
  }
  /* Numéro de la question et total estimé pour la barre de progression */
  progress(path, a, qid) {
    const ids = this.QUESTIONS[path].map((q) => q.id);
    return { index: ids.indexOf(qid) + 1, total: ids.length };
  }

  /* ---------- Filtres durs ---------- */
  candidates(path, a) {
    let hs = this.handles(path);
    const C = this.CATALOGUE;
    if (path === 'colonne') {
      if (a.usage === 'bain') return hs.filter((h) => C[h].bain);
      if (a.travaux === 'garde') return hs.filter((h) => C[h].pose === 'sm');
      if (a.travaux === 'non') return hs.filter((h) => C[h].pose === 'app');
      if (a.travaux === 'oui') return hs.filter((h) => C[h].pose === 'app' || C[h].pose === 'enc');
      return hs.filter((h) => C[h].pose !== 'sm');
    }
    if (path === 'robinet') {
      if (!a.vasque || a.vasque === 'nsp') return hs;
      return hs.filter((h) => C[h].vasque.includes(a.vasque));
    }
    if (path === 'wc') {
      if (a.eau === 'froide') return hs.filter((h) => C[h].eau === 'froide');
      if (a.eau === 'chaude') {
        hs = hs.filter((h) => C[h].eau === 'chaude');
        if (a.forme && a.forme !== 'any') hs = hs.filter((h) => C[h].forme === a.forme);
        return hs;
      }
      return hs;
    }
    return hs;
  }
  finishOptions(path, a) {
    const set = new Set();
    this.candidates(path, a).forEach((h) => this.finishesOf(h).forEach((f) => set.add(f)));
    return this.FINISHES.filter((f) => set.has(f.id)).map((f) => f.id);
  }

  /* ---------- Score ---------- */
  evaluate(path, a, h) {
    /* Poids : la sécurité (enfants, seniors) compte plus que l'envie, l'envie plus que la finition. */
    const c = this.CATALOGUE[h]; const crit = []; let bonus = 0;
    if (path === 'colonne') {
      if (a.qui === 'enfants' || a.qui === 'seniors') {
        crit.push({ k: 'thermo', w: 3, ok: !!c.thermo });
        if (c.secu) bonus += 1;
      }
      if (a.envie) {
        if (a.envie === 'pluie') { if (c.big) bonus += 1; }
        else crit.push({ k: 'envie', w: 2, ok: c.exp.includes(a.envie) });
      }
      if (a.travaux === 'oui' && c.pose === 'enc') bonus += 0.5;
    }
    if (path === 'robinet' && a.vasque === 'basse' && h === 'mitigeur-lavabo-bec-haut-vasque-a-poser') bonus += 1;
    if (a.finition && a.finition !== 'any') crit.push({ k: 'finition', w: 1, ok: this.finishesOf(h).includes(a.finition) });
    const score = crit.reduce((t, x) => t + (x.ok ? x.w : 0), 0);
    const max = crit.reduce((t, x) => t + x.w, 0);
    return { h, crit, score, max, bonus, rank: c.rank || 99 };
  }

  lines(path, a, ev, tier) {
    const c = this.CATALOGUE[ev.h]; const out = [];
    /* Une seule différence affichée (la plus importante), puis les atouts. */
    ev.crit.filter((x) => !x.ok).sort((x, y) => y.w - x.w).slice(0, 1).forEach((x) => {
      if (x.k === 'thermo') out.push({ miss: true, text: 'Mitigeur mécanique, sans thermostatique' });
      if (x.k === 'envie') out.push({ miss: true, text: this.ENVIE_MISS[a.envie] });
      if (x.k === 'finition') {
        const others = this.finishesOf(ev.h).slice(0, 3).map((f) => this.finish(f).label).join(', ');
        out.push({ miss: true, text: 'Pas en ' + this.finish(a.finition).label.toLowerCase() + (others ? ' : existe en ' + others.toLowerCase() : '') });
      }
    });
    if (path === 'colonne' && a.usage === 'bain') {
      out.push({ text: c.pose === 'app' ? 'Sans travaux : se pose sur vos arrivées actuelles' : 'Encastrée : à prévoir pendant une rénovation' });
    }
    if (path === 'colonne' && (a.qui === 'enfants' || a.qui === 'seniors') && c.thermo && !c.secu) {
      out.push({ text: 'Température stable, sans à-coup brûlant' });
    }
    c.why.forEach((w) => out.push({ text: w }));
    const seen = new Set();
    return out.filter((l) => l.text && !seen.has(l.text) && seen.add(l.text)).slice(0, 2);
  }

  rank(path, a, hs) {
    return hs.map((h) => this.evaluate(path, a, h)).sort((x, y) =>
      (y.score - x.score) || (y.bonus - x.bonus) || (x.rank - y.rank) || (this.price(x.h) - this.price(y.h)));
  }

  card(path, a, ev, tier) {
    return { h: ev.h, variant: this.variantFor(ev.h, a), lines: this.lines(path, a, ev, tier), price: this.price(ev.h) };
  }

  /* ---------- Résultats ---------- */
  results(path, a) {
    const cands = this.candidates(path, a);
    const ranked = this.rank(path, a, cands);
    const maxScore = ranked.length ? ranked[0].max : 0;
    const top = ranked.length ? ranked[0].score : 0;
    let best = ranked.filter((e) => e.score === top);
    const rest = ranked.filter((e) => e.score < top);
    /* « À considérer aussi » : d'abord le meilleur modèle qui satisfait chaque critère manqué
       par la sélection principale (diversité), puis les suivants par score. */
    let near = [];
    if (best.length) {
      best[0].crit.filter((x) => !x.ok).forEach((x) => {
        const alt = rest.find((e) => !near.includes(e) && e.crit.some((y) => y.k === x.k && y.ok));
        if (alt) near.push(alt);
      });
    }
    rest.forEach((e) => { if (near.length < 4 && !near.includes(e)) near.push(e); });
    const allMatch = top === maxScore;
    const R = { title: '', sub: '', banner: '', best: [], near: [], ensemble: null, budget: false, nearTitle: 'À considérer aussi' };

    if (path === 'colonne') {
      if (a.usage === 'bain') {
        best = ranked.slice().sort((x, y) => (this.CATALOGUE[x.h].pose === 'app' ? 0 : 1) - (this.CATALOGUE[y.h].pose === 'app' ? 0 : 1) || this.price(x.h) - this.price(y.h));
        near = [];
        const app = best.filter((e) => this.CATALOGUE[e.h].pose === 'app').length; const enc = best.length - app;
        R.title = 'Les colonnes qui alimentent aussi votre baignoire';
        R.sub = this.plural(app, 'se pose', 'se posent') + ' sur vos arrivées actuelles, ' + this.plural(enc, 's\'encastre', 's\'encastrent') + ' lors d\'une rénovation.';
      } else if (a.travaux === 'garde') {
        R.title = 'Gardez votre mitigeur, changez tout le reste';
        R.sub = 'Cette colonne se branche sur votre sortie d\'eau actuelle : pluie et douchette sans toucher à la plomberie.';
      } else {
        R.budget = true;
        R.title = allMatch ? 'Les colonnes faites pour votre douche' : 'Les colonnes les plus proches de vos réponses';
        R.sub = allMatch
          ? this.count(best.length) + ' à toutes vos réponses.'
          : 'Aucun modèle ne réunit toutes vos réponses. Sous chaque modèle, nous indiquons ce qui diffère.';
        if (a.travaux === 'non') R.banner = 'Tous ces modèles se posent sur vos arrivées d\'eau actuelles, sans travaux.';
        if (a.travaux === 'oui') R.banner = 'Les modèles encastrés se posent pendant la rénovation, avant le carrelage.';
        if (a.finition && a.finition !== 'any') R.ensemble = this.ensemble(a.finition);
      }
    } else if (path === 'robinet') {
      R.title = allMatch ? 'Les robinets faits pour votre lavabo' : 'Les robinets les plus proches de vos réponses';
      R.sub = a.vasque === 'nsp'
        ? 'Repère simple : au-delà de 12 cm de bord de vasque, prenez un bec haut XL.'
        : (allMatch ? this.count(best.length) + ' à votre vasque et à votre finition.' : 'Ces modèles conviennent à votre vasque, pas encore dans la finition choisie.');
    } else if (path === 'wc') {
      if (a.eau === 'froide') {
        R.title = 'La douchette qui se branche sur votre chasse d\'eau';
        R.sub = 'Aucune arrivée d\'eau à créer : le kit remplace votre robinet d\'arrêt par un modèle à deux sorties.';
      } else if (a.eau === 'nsp') {
        best = ranked.filter((e) => this.CATALOGUE[e.h].eau === 'froide');
        near = ranked.filter((e) => this.CATALOGUE[e.h].eau === 'chaude');
        R.title = 'Dans le doute, partez sur l\'eau froide';
        R.sub = 'C\'est l\'installation de la grande majorité des WC. Si vous avez aussi l\'eau chaude, les modèles à mitigeur règlent la température.';
        R.nearTitle = 'Si vous avez l\'eau chaude aux WC';
      } else {
        R.title = allMatch ? 'Les douchettes faites pour vos WC' : 'Les douchettes les plus proches de vos réponses';
        R.sub = 'Le mitigeur règle la température avant que le jet parte, comme sur un lavabo.';
      }
    }

    R.best = best.map((e) => this.card(path, a, e, 'best'));
    R.near = near.slice(0, 4).map((e) => {
      const card = this.card(path, a, e, 'near');
      if (path === 'wc' && a.eau === 'nsp') card.lines = [{ miss: true, text: 'Nécessite une arrivée d\'eau chaude aux WC' }].concat(card.lines).slice(0, 2);
      return card;
    });
    return R;
  }

  ensemble(fin) {
    const a = { finition: fin };
    const rob = this.handles('robinet').filter((h) => this.finishesOf(h).includes(fin))
      .sort((x, y) => this.CATALOGUE[x].rank - this.CATALOGUE[y].rank).slice(0, 3);
    const wc = this.handles('wc').filter((h) => this.finishesOf(h).includes(fin))
      .sort((x, y) => this.CATALOGUE[x].rank - this.CATALOGUE[y].rank);
    const items = rob.concat(wc).map((h) => {
      const c = this.CATALOGUE[h];
      const lines = c.eau === 'chaude'
        ? [{ text: 'Nécessite l\'eau chaude à côté des WC' }, { text: c.why[0] }]
        : [{ text: c.why[0] }, { text: c.why[1] }];
      return { h, variant: this.variantFor(h, a), lines, price: this.price(h) };
    });
    if (!items.length) return null;
    return { title: 'Toute votre salle de bain en ' + this.finish(fin).label.toLowerCase(), sub: 'Le robinet et la douchette WC dans la même finition que votre colonne.', items };
  }

  plural(n, one, many) { return n + ' ' + (n > 1 ? many : one); }
  count(n) { return n > 1 ? n + ' modèles correspondent' : 'Ce modèle correspond'; }

  /* ---------- Libellés du récapitulatif ---------- */
  recap(path, a) {
    const out = [];
    this.QUESTIONS[path].forEach((q) => {
      const v = a[q.id]; if (!v) return;
      if (q.type === 'finish') { out.push(v === 'any' ? 'Toutes finitions' : this.finish(v).label); return; }
      const o = q.options.find((x) => x.v === v); if (o) out.push(o.l);
    });
    return out;
  }
  serialize(a) { return Object.keys(a).map((k) => k + '-' + a[k]).join('.'); }
  parse(path, s) {
    const a = {}; if (!s || !this.QUESTIONS[path]) return a;
    s.split('.').forEach((pair) => {
      const i = pair.indexOf('-'); if (i < 1) return;
      const k = pair.slice(0, i); const v = pair.slice(i + 1);
      const q = this.question(path, k); if (!q) return;
      if (q.type === 'finish') { if (v === 'any' || this.finish(v)) a[k] = v; }
      else if (q.options.some((o) => o.v === v)) a[k] = v;
    });
    return a;
  }
}

/* ============================================================
   INTERFACE DU QUIZ (custom element <ladd-quiz>)
   ============================================================ */
class LaddQuiz extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;

    this.ga4 = (this.dataset.ga4 || '').trim();
    if (this.ga4 && typeof window.gtag === 'function') {
      window.gtag('config', this.ga4, { send_page_view: false });
    }

    /* Lecture des produits rendus par Liquid */
    this.pool = this.querySelector('[data-pool]');
    this.items = {};
    const products = {};
    this.pool.querySelectorAll('[data-quiz-item]').forEach((el) => {
      const h = el.dataset.handle;
      if (this.items[h]) { el.remove(); return; }
      this.items[h] = el;
      let variants = [];
      try { variants = JSON.parse(el.querySelector('[data-variants]').textContent); } catch (e) { /* aucune variante lisible */ }
      products[h] = { price: parseInt(el.dataset.price, 10) || 0, url: el.dataset.url, variants };
    });
    this.engine = new LaddQuizEngine(products);

    this.screens = {};
    this.querySelectorAll('[data-screen]').forEach((s) => { this.screens[s.dataset.screen] = s; });
    this.tplArrow = this.querySelector('[data-tpl-arrow]');
    this.tplCheck = this.querySelector('[data-tpl-check]');

    this.path = null;
    this.answers = {};
    this.history = [];
    this.budget = null;
    this.expanded = false;

    this.addEventListener('click', (e) => this.onClick(e));
    this.addEventListener('click', (e) => this.onProductClick(e), true);
    const form = this.querySelector('[data-newsletter] form');
    if (form) form.addEventListener('submit', () => this.beforeNewsletter(form));

    this.restore();
  }

  /* ---------- Navigation ---------- */
  show(name) {
    Object.keys(this.screens).forEach((k) => { this.screens[k].hidden = k !== name; });
    this.dataset.state = name;
  }

  scrollTop() {
    const r = this.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * 0.5) {
      window.scrollTo({ top: window.scrollY + r.top - 80, behavior: 'smooth' });
    }
  }

  start(path, answers) {
    if (!this.engine.QUESTIONS[path]) return;
    this.path = path;
    this.answers = answers || {};
    this.history = [];
    this.budget = null;
    this.expanded = false;
    this.track('quiz_start', {});
    this.step();
  }

  step() {
    const q = this.engine.next(this.path, this.answers);
    if (q === 'results') { this.renderResults(true); return; }
    this.renderQuestion(q);
  }

  renderQuestion(qid) {
    const q = this.engine.question(this.path, qid);
    const s = this.screens.question;
    const pr = this.engine.progress(this.path, this.answers, qid);
    s.querySelector('[data-q-step]').textContent = 'Question ' + pr.index + ' sur ' + pr.total;
    const bar = s.querySelector('[data-q-bar]');
    bar.style.setProperty('--progress', Math.round(((pr.index - 1) / pr.total) * 100) + '%');
    bar.setAttribute('aria-valuenow', String(pr.index));
    bar.setAttribute('aria-valuemax', String(pr.total));
    const title = s.querySelector('[data-q-title]');
    title.textContent = q.title;
    const help = s.querySelector('[data-q-help]');
    help.textContent = q.help || '';
    help.hidden = !q.help;

    const box = s.querySelector('[data-q-options]');
    box.innerHTML = '';
    box.classList.toggle('ladd-quiz__options--finish', q.type === 'finish');
    let options = q.options;
    if (q.type === 'finish') {
      options = this.engine.finishOptions(this.path, this.answers).map((id) => {
        const f = this.engine.finish(id); return { v: id, l: f.label, bg: f.bg };
      });
      options.push({ v: 'any', l: 'Peu importe' });
    }
    options.forEach((o) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ladd-quiz__option';
      b.dataset.action = 'answer';
      b.dataset.q = qid;
      b.dataset.v = o.v;
      b.setAttribute('aria-pressed', this.answers[qid] === o.v ? 'true' : 'false');
      if (o.bg) {
        const sw = document.createElement('span');
        sw.className = 'ladd-quiz__swatch';
        sw.style.setProperty('--swatch', o.bg);
        b.appendChild(sw);
      }
      const txt = document.createElement('span');
      txt.className = 'ladd-quiz__option-text';
      const l = document.createElement('span');
      l.className = 'ladd-quiz__option-label';
      l.textContent = o.l;
      txt.appendChild(l);
      if (o.h) {
        const h = document.createElement('span');
        h.className = 'ladd-quiz__option-help';
        h.textContent = o.h;
        txt.appendChild(h);
      }
      b.appendChild(txt);
      if (this.tplArrow) b.appendChild(this.tplArrow.content.cloneNode(true));
      box.appendChild(b);
    });

    s.querySelector('[data-action="back"]').hidden = false;
    this.currentQ = qid;
    this.show('question');
    this.scrollTop();
    title.focus({ preventScroll: true });
  }

  answer(qid, v) {
    this.history.push(qid);
    this.answers[qid] = v;
    this.track('quiz_answer', { quiz_question: qid, quiz_answer: v, quiz_step: this.history.length });
    this.step();
  }

  back() {
    if (!this.history.length) { this.show('intro'); this.path = null; this.scrollTop(); return; }
    const prev = this.history.pop();
    delete this.answers[prev];
    this.renderQuestion(prev);
  }

  /* ---------- Résultats ---------- */
  renderResults(fresh) {
    const R = this.engine.results(this.path, this.answers);
    const s = this.screens.results;
    this.returnItems();

    s.querySelector('[data-r-title]').textContent = R.title;
    s.querySelector('[data-r-sub]').textContent = R.sub;

    const recap = s.querySelector('[data-r-recap]');
    recap.innerHTML = '';
    this.engine.recap(this.path, this.answers).forEach((t) => {
      const li = document.createElement('li');
      li.className = 'badge badge--secondary';
      li.textContent = t;
      recap.appendChild(li);
    });

    const banner = s.querySelector('[data-r-banner]');
    banner.hidden = !R.banner;
    banner.querySelector('[data-r-banner-text]').textContent = R.banner || '';

    const budgetBox = s.querySelector('[data-r-budget]');
    budgetBox.hidden = !R.budget || R.best.length + R.near.length < 4;
    budgetBox.querySelectorAll('[data-budget]').forEach((b) => {
      b.setAttribute('aria-pressed', this.budget === b.dataset.budget ? 'true' : 'false');
    });

    const inBudget = (c) => {
      if (!R.budget || !this.budget) return true;
      const [min, max] = this.budget.split('-').map(Number);
      return c.price >= min * 100 && c.price < max * 100;
    };
    const best = R.best.filter(inBudget);
    const near = R.near.filter(inBudget);

    const bestGrid = s.querySelector('[data-r-best]');
    const limit = this.expanded ? 999 : 6;
    best.forEach((c, i) => this.place(c, bestGrid, 'best', i >= limit));
    const more = s.querySelector('[data-action="more"]');
    more.hidden = best.length <= limit;
    const extra = best.length - limit;
    more.textContent = extra > 1 ? 'Voir les ' + extra + ' autres modèles' : 'Voir l\'autre modèle';

    const empty = s.querySelector('[data-r-empty]');
    empty.hidden = best.length > 0;

    const nearWrap = s.querySelector('[data-r-near-wrap]');
    nearWrap.hidden = !near.length;
    nearWrap.querySelector('[data-r-near-title]').textContent = R.nearTitle;
    const nearGrid = s.querySelector('[data-r-near]');
    near.forEach((c) => this.place(c, nearGrid, 'near'));

    const ensWrap = s.querySelector('[data-r-ensemble-wrap]');
    ensWrap.hidden = !R.ensemble;
    if (R.ensemble) {
      ensWrap.querySelector('[data-r-ensemble-title]').textContent = R.ensemble.title;
      ensWrap.querySelector('[data-r-ensemble-sub]').textContent = R.ensemble.sub;
      const g = ensWrap.querySelector('[data-r-ensemble]');
      R.ensemble.items.forEach((c) => this.place(c, g, 'ensemble'));
    }

    this.show('results');
    if (fresh) {
      this.writeUrl();
      this.track('quiz_complete', { quiz_answers: this.engine.serialize(this.answers), quiz_results: best.length });
      this.scrollTop();
      s.querySelector('[data-r-title]').focus({ preventScroll: true });
    }
  }

  place(card, grid, zone, hiddenByLimit) {
    const el = this.items[card.h];
    if (!el) return;
    const url = el.dataset.url + (card.variant ? '?variant=' + card.variant : '');
    el.dataset.zone = zone;
    el.dataset.link = url;
    const pc = el.querySelector('product-card');
    if (pc) { pc.dataset.productUrl = url; pc.productUrl = url; }
    el.querySelectorAll('a[href*="/products/"]').forEach((a) => { a.href = url; });

    /* Photo de la finition choisie, quand la variante en a une */
    const img = el.querySelector('product-card img');
    if (img) {
      if (!img.dataset.origSrc) { img.dataset.origSrc = img.getAttribute('src') || ''; img.dataset.origSrcset = img.getAttribute('srcset') || ''; }
      const v = (this.engine.products[card.h].variants || []).find((x) => String(x.id) === String(card.variant));
      if (v && v.img) { img.setAttribute('src', v.img); img.removeAttribute('srcset'); }
      else { img.setAttribute('src', img.dataset.origSrc); if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset); }
    }

    const why = el.querySelector('[data-why]');
    why.innerHTML = '';
    card.lines.forEach((l) => {
      const li = document.createElement('li');
      li.className = 'ladd-quiz__why-line' + (l.miss ? ' ladd-quiz__why-line--miss' : '');
      if (!l.miss && this.tplCheck) li.appendChild(this.tplCheck.content.cloneNode(true));
      const t = document.createElement('span');
      t.textContent = l.text;
      li.appendChild(t);
      why.appendChild(li);
    });
    why.hidden = !card.lines.length;
    el.hidden = !!hiddenByLimit;
    grid.appendChild(el);
  }

  returnItems() {
    Object.keys(this.items).forEach((h) => {
      const el = this.items[h];
      el.hidden = true;
      this.pool.appendChild(el);
    });
  }

  /* ---------- Clics ---------- */
  onClick(e) {
    const t = e.target.closest('[data-action]');
    if (!t || !this.contains(t)) return;
    const a = t.dataset.action;
    if (a === 'path') { this.start(t.dataset.path, {}); }
    else if (a === 'answer') { this.answer(t.dataset.q, t.dataset.v); }
    else if (a === 'back') { this.back(); }
    else if (a === 'restart') { this.track('quiz_restart', {}); this.path = null; this.answers = {}; this.clearUrl(); this.returnItems(); this.show('intro'); this.scrollTop(); }
    else if (a === 'edit') { this.start(this.path, {}); }
    else if (a === 'more') { this.expanded = true; this.renderResults(false); }
    else if (a === 'budget-filter') {
      this.budget = this.budget === t.dataset.budget ? null : t.dataset.budget;
      this.expanded = false;
      this.track('quiz_budget', { quiz_budget: this.budget || 'tous' });
      this.renderResults(false);
    }
    else if (a === 'copy') { this.copyLink(t); }
  }

  onProductClick(e) {
    const item = e.target.closest('[data-quiz-item]');
    if (!item || !this.contains(item) || item.parentElement === this.pool) return;
    this.track('quiz_product_click', { item_id: item.dataset.handle, quiz_zone: item.dataset.zone || '' });
    /* Attribut de panier : la commande indiquera qu'elle vient du quiz */
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { Quiz: this.path + ' | ' + this.engine.serialize(this.answers) } }),
      });
    } catch (err) { /* sans effet sur la navigation */ }
  }

  copyLink(btn) {
    const done = () => {
      const label = btn.querySelector('[data-copy-label]');
      if (label) { const old = label.textContent; label.textContent = 'Lien copié'; setTimeout(() => { label.textContent = old; }, 2500); }
      this.track('quiz_share', {});
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(window.location.href).then(done, () => {});
  }

  /* ---------- URL et restauration ---------- */
  writeUrl() {
    try {
      const u = new URL(window.location.href);
      u.searchParams.set('parcours', this.path);
      u.searchParams.set('rep', this.engine.serialize(this.answers));
      window.history.replaceState({}, '', u.toString());
    } catch (e) { /* navigateur ancien */ }
  }

  clearUrl() {
    try {
      const u = new URL(window.location.href);
      u.searchParams.delete('parcours'); u.searchParams.delete('rep');
      window.history.replaceState({}, '', u.toString());
    } catch (e) { /* navigateur ancien */ }
  }

  beforeNewsletter(form) {
    const tags = form.querySelector('[data-quiz-tags]');
    if (tags && this.path) {
      const parts = ['newsletter', 'quiz', 'quiz-' + this.path];
      if (this.answers.finition && this.answers.finition !== 'any') parts.push('finition-' + this.answers.finition);
      tags.value = parts.join(', ');
    }
    try { sessionStorage.setItem('laddQuiz', JSON.stringify({ path: this.path, answers: this.answers })); } catch (e) { /* stockage indisponible */ }
  }

  restore() {
    let path = null; let answers = {};
    try {
      const u = new URL(window.location.href);
      path = u.searchParams.get('parcours');
      if (path && this.engine.QUESTIONS[path]) answers = this.engine.parse(path, u.searchParams.get('rep'));
      else path = null;
    } catch (e) { path = null; }

    const posted = this.querySelector('[data-newsletter-posted]');
    if (posted) {
      try {
        const saved = JSON.parse(sessionStorage.getItem('laddQuiz') || 'null');
        if (saved && this.engine.QUESTIONS[saved.path]) { path = saved.path; answers = saved.answers || {}; }
        sessionStorage.removeItem('laddQuiz');
      } catch (e) { /* stockage indisponible */ }
    }

    if (!path) { this.show('intro'); return; }
    this.path = path; this.answers = answers; this.history = [];
    if (this.engine.next(path, answers) === 'results' && Object.keys(answers).length) {
      this.renderResults(false);
      if (posted) posted.scrollIntoView({ block: 'center' });
    } else {
      this.start(path, answers);
    }
  }

  /* ---------- Mesure ---------- */
  track(name, params) {
    if (typeof window.gtag !== 'function') return;
    const p = Object.assign({ quiz_path: this.path || '' }, params);
    if (this.ga4) p.send_to = this.ga4;
    window.gtag('event', name, p);
  }
}

if (!customElements.get('ladd-quiz')) customElements.define('ladd-quiz', LaddQuiz);

  } catch(e) { console.error(e); }
})();
})();
